import { inputSlotClassNames } from '../../../../components/Input/Input';
export var datepickerStyles = {
  root: function root(_ref) {
    var _ref2;

    var p = _ref.props;
    return Object.assign({}, !p.allowManualInput && (_ref2 = {}, _ref2["& ." + inputSlotClassNames.input] = {
      cursor: 'pointer'
    }, _ref2));
  }
};
//# sourceMappingURL=datepickerStyles.js.map
